export default __webpack_public_path__ + "static/media/leftarrow.d07fec8f.svg";